export const ButtonT3Size = Object.freeze({
  DEFAULT: '', // So it works as a knob in storybook
  SMALL: 'small',
  // No medium because it is the default.
  LARGE: 'large',
  EXTRA_LARGE: 'extraLarge',
});

export const ButtonT3Theme = Object.freeze({
  DEFAULT: '', // So it works as a knob in storybook
  LIGHT: 'light',
  DARK: 'dark',
  LIGHT_TRANSPARENT: 'lightTransparent',
  DARK_TRANSPARENT: 'darkTransparent',
  WHITE: 'white',
  BLACK: 'black',
  OPAQUE_WHITE: 'opaqueWhite',
  ADS: 'ads',
  PANDORA_PLUS: 'plus',
  PANDORA_PREMIUM: 'premium',
});

export const ButtonT3Type = Object.freeze({
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
});
